module.exports = __webpack_public_path__ + "static/media/image1c.a6941a58.jpg";